// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/login.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".login-form[data-v-b2aa59b2] {\n  border-radius: 4px;\n}\na[data-v-b2aa59b2] {\n  text-decoration: none;\n}\n.bg-img[data-v-b2aa59b2] {\n  height: 100vh;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-image: no-repeat fixed center;\n  background-size: cover;\n}\n.cursor[data-v-b2aa59b2] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
